import { HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils";
import HeaderGroup from "./HeaderGroup";

type HeadersProps<T extends object> = { headerGroups: HeaderGroupType<T>[] };

const Headers = genericMemo(
  <T extends object>({ headerGroups, ...restProps }: HeadersProps<T>) => {
    return (
      <div role="rowheader" {...restProps}>
        {
          headerGroups.map(headerGroup =>
            <HeaderGroup headers={headerGroup.headers} {...headerGroup.getHeaderGroupProps()} />,
          )
        }
      </div>
    );
  },
);

export default Headers;
